"use client"

import { useCallback, useRef, useState } from "react"
import {
  markFirstPullResultClosed,
  markInstantBuybackIntroSeen,
  shouldShowInstantBuybackIntro,
  shouldShowInstantBuybackIntroAfterBuybackAccepted,
} from "./gacha-instant-buyback-intro-storage"

type UseGachaInstantBuybackIntroOptions = {
  onActivateInstantBuyback?: () => void
}

export function useGachaInstantBuybackIntro({
  onActivateInstantBuyback,
}: UseGachaInstantBuybackIntroOptions = {}) {
  const usedBuybackRef = useRef(false)
  const [introOpen, setIntroOpen] = useState(false)

  const resetForNewPull = useCallback(() => {
    usedBuybackRef.current = false
  }, [])

  const markBuybackUsed = useCallback(() => {
    usedBuybackRef.current = true
  }, [])

  const handleResultDialogClosed = useCallback(() => {
    const showIntro = usedBuybackRef.current
      ? shouldShowInstantBuybackIntroAfterBuybackAccepted()
      : shouldShowInstantBuybackIntro()
    markFirstPullResultClosed()

    if (showIntro) {
      setIntroOpen(true)
    }
  }, [])

  const handleIntroOpenChange = useCallback((open: boolean) => {
    if (!open) {
      markInstantBuybackIntroSeen()
    }

    setIntroOpen(open)
  }, [])

  const handleActivateInstantBuyback = useCallback(() => {
    markInstantBuybackIntroSeen()
    onActivateInstantBuyback?.()
    setIntroOpen(false)
  }, [onActivateInstantBuyback])

  return {
    introOpen,
    resetForNewPull,
    markBuybackUsed,
    handleResultDialogClosed,
    handleIntroOpenChange,
    handleActivateInstantBuyback,
  }
}
